import { useMutation } from "@tanstack/react-query";
import { apiV2Root } from "consts";

import type { RunResponse, ScriptValues } from "./data/types";

type RunArgs = { name: string; params: ScriptValues };

/** Запускает скрипт наполнения БД; при ошибке бросает Error с текстом сервера. */
export const useRunScript = () =>
  useMutation<RunResponse, Error, RunArgs>({
    mutationFn: async ({ name, params }) => {
      const response = await fetch(`${apiV2Root}admin/scripts/${name}/run/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ params }),
      });
      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data?.error || `HTTP ${response.status}`);
      }

      return data;
    },
  });
